import wrappedAxios from "../axiosWrapper";
import * as UP from "./urlParsers";

export const impersonate = (userId: number) =>
  wrappedAxios<string>({
    method: "get",
    url: UP.impersonate(userId),
  });

export const isImpersonating = () =>
  wrappedAxios<number>({
    method: "get",
    url: UP.isImpersonating(),
  });

export const cancelImpersonization = () =>
  wrappedAxios<string>({
    method: "get",
    url: UP.cancelImpersonization(),
  });
